import {axios} from '@/api/axios';
import {INITIATOR_URLS} from '@/api/urls';
import {formatString} from '@/utils';
import {InitiatorClass} from '@/types/InitiatorClass';

export const InitiatorApi = {
  getList: () => axios.get<InitiatorClass[]>(INITIATOR_URLS.GET_LIST),
  getOne: (id: string) => axios.get<InitiatorClass>(formatString(INITIATOR_URLS.GET_ONE, id)),
  save: (data: InitiatorClass) => axios.post<InitiatorClass>(INITIATOR_URLS.SAVE, data),
  edit: (id: string | null, data: InitiatorClass) => axios.put<InitiatorClass>(formatString(INITIATOR_URLS.EDIT, id), data),
  delete: (id: string | null) => axios.delete<InitiatorClass>(formatString(INITIATOR_URLS.EDIT, id))
};
